// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"__3Vw2Vx_O","searchResults":"lp8fg42E","row":"ujqJd_Xm","column":"niq2wvMP","list":"Ejmvft7k","title":"uOV_O_Yj","item":"PiDNkXvj"};